export interface IAnnouncementModel {
    guid: string;
    title: string;
    text: string;
    variant?: AnnoucementVariant;
    icon?: string;
    pageMarkup?: string;
    routeKey: string;
    isActive: boolean;
    isBlocking: boolean;
    effectiveDate?: string;
    announcementTypeId: AnnouncementType;
}

export enum AnnouncementType {
    Global = 1,
    Page = 2,
    Public = 3
}

export enum AnnoucementVariant {
    Info = 'info',
    Danger = 'danger'
}